import React from "react";
import {
  Box,
  Skeleton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

export default function AccordionSkeleton({
  count = 3,
  expanded = [],
  summaryWidth = "60%",
  detailsHeight = 40,
}) {
  return (
    <Box sx={{ p: 2 }}>
      {[...Array(count)].map((_, idx) => (
        <Accordion key={idx} expanded={expanded[idx] || false} sx={{ mb: 2 }}>
          <AccordionSummary>
            <Skeleton variant="text" width={summaryWidth} height={28} />
          </AccordionSummary>
          <AccordionDetails>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={detailsHeight}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
